import { schemes } from "@zeal/common";
import { z } from "zod";

export const getFinixCardsRequestSchema = z.object({
  customerAccountID: schemes.uuid(),
});

export type TGetFinixCardsRequestSchema = z.infer<
  typeof getFinixCardsRequestSchema
>;

export const getFinixCardsResponseSchema = z.object({
  cards: z.array(
    z.object({
      id: z.string(),
      lastFour: z.string(),
      brand: z.string(),
      expDate: z.string(),
    })
  ),
});

export type TGetFinixCardsResponseSchema = z.infer<
  typeof getFinixCardsResponseSchema
>;
